
import { defineComponent, watch, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import useArticle from "@/composables/useArticle";
import RichText from "@/components/common/RichText.vue";
import PageTitle from "@/components/common/PageTitle.vue";
import { imageUrlBuilder } from "@/services/sanity";
import Grid from "@moonlight/vue3/components/Grid.vue";
import { formatDateLong } from "@/utils/dateTimeFormatter";
import { useMediaQuery } from "@vueuse/core";
import Loading from "@/components/common/Loading.vue";
import { useHead } from "@vueuse/head";
export default defineComponent({
  components: {
    RichText,
    Grid,
    PageTitle,
    Loading,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const isDesktop = useMediaQuery("(min-width: 800px)");

    const router = useRouter();
    const { article, fetchArticle, requestState } = useArticle();

    onMounted(async () => {
      await fetchArticle(props.slug);
      if (!article.value) {
        router.replace("/404");
      }
    });

    watch(
      () => props.slug,
      async () => {
        await fetchArticle(props.slug);
        if (!article.value) {
          router.replace("/404");
        }
      }
    );

    useHead({
      title: computed(() => article.value?.title as string),
      meta: [
        {
          name: `description`,
          content: computed(
            () => article.value?.body?.[0]?.children?.[0]?.text as string
          ),
        },
      ],
    });

    return {
      isDesktop,
      article,
      imageUrlBuilder,
      requestState,
      formatDateLong,
    };
  },
});
